jQuery(document).ready(function ($) {

	//ABRIR MENU MOBILE
	$('.abrir-menu-container, .menu-mobile .botao-fechar').click(function(e) {
		e.preventDefault();
		if(!$('.menu-mobile').hasClass('menu-site-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	$('.menu-overlay').click(function(e) {
		e.preventDefault();
		if(!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	function abreMenu() {
		$('.menu-mobile').addClass('menu-site-aberto');
		$('.menu-overlay').addClass('menu-overlay-aberto');
	}
	function fechaMenu() {
		$('.menu-mobile').removeClass('menu-site-aberto');
		$('.menu-overlay').removeClass('menu-overlay-aberto');
	}

	//ABRIR BUSCA
	$('#abrir-busca, .botao-fechar-busca').click(function(e) {
		e.preventDefault();
		if(!$('#busca').hasClass('menu-site-aberto')) {
			$('#busca').addClass('menu-site-aberto');
		} else {
			$('#busca').removeClass('menu-site-aberto');
		}
	});

	//MIN E MAX NA BUSCA
	$('#busca-imoveis, #busca-veiculos').submit(function(e) {
		var min = parseInt($('#valor_minimo').val());
		var max = parseInt($('#valor_maximo').val());
		//console.log('min: '+min+' max:'+max);

		if(max <= min) {
			alert('O valor máximo deve ser MAIOR que o valor mínimo.');
			e.preventDefault();
			$('#valor_maximo').focus();
		}
	});

	//MAGNIFY
	$(".galeria-carrosel a").magnificPopup({
		type: "image",
		gallery: {
			enabled: true,
			tPrev: "Anterior",
			tNext: "Próxima",
			tCounter: "%curr% de %total%",
		},
	});

	//STICKY SIDEBAR
	$('.sticky-sidebar').theiaStickySidebar({
		//'additionalMarginTop': 150,
		'minWidth': 780,
		'updateSidebarHeight':true
	});

	//CARROSSEIS
	$('.equipe-carrosel').owlCarousel({
		loop:true,
		margin:30,
		autoplay:true,
		autoplayTimeout:12000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:4
			}
		}
	});


	$('.galeria-carrosel').owlCarousel({
		loop:true,
		margin:0,
		autoplay:true,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:3
			},
			1000:{
				items:4
			}
		}
	});

	$('.imoveis-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:false,
		autoplayTimeout:10000,
		dots:true,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:4
			}
		}
	});

  $('.tipos-carrosel').owlCarousel({
    loop:true,
    margin:30,
    autoplay:false,
    autoplayTimeout:10000,
    dots:true,
    lazyLoad: true,
    navText:["&#8592;","&#8594;"],
    nav:true,
    autoHeight: true,
    responsive:{
      0:{
        items:2
      },
      600:{
        items:3
      },
      1000:{
        items:5
      }
    }
  });

	//FIX HEADER
	window.onscroll = function() { fixHeader() };
	function fixHeader() {
		if (window.pageYOffset > 100) {
			$('body:not(.single-imoveis):not(.post-type-archive-imoveis) #topo').addClass('scrooled');
		} else {
			$('body:not(.single-imoveis):not(.post-type-archive-imoveis) #topo').removeClass('scrooled');
		}
	}

	//FIX HEADER ON SCROOLL
	/*var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = 250;

	$(window).scroll(function(event){
		didScroll = true;
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = $(this).scrollTop();

		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
			return;

		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight){
			// Scroll Down
			$('#topo').removeClass('scrooled');
		} else {
			// Scroll Up
			if(st + $(window).height() < $(document).height()) {
				$('#topo').addClass('scrooled');
			}
		}

		lastScrollTop = st;
	}*/

});